<template>
	<SimpleCrud
		:no_title="no_title"
    :beforeSetRows="beforeSetRows"
		:gets_on_created="gets_on_created"
		:headers="headers"
		:name="c_name"
		:config_name="rq_name"
		:scheme="{}"
		:canDetail="false"
		:canDelete="false"
		:canAdd="false"
		:preFilters.sync="preFilters">
		<template slot="crud-title">{{title}}</template>
	</SimpleCrud>
</template>

<script>
import {
	inpAreasNames,
  set_max_mfl_atrs,
	fN
} from '@/functions/general.js';

export default {
	props:['gets_on_created','pre_name','title','no_title'],
	data() {
		return {
    	headers: [

				{ text: 'Organización', sortable: true, value: 'organization_name' },
				{ text: 'Activo / Equipo', sortable: false, value: 'name' },
				{ text: 'TAG Equipo', sortable: false, value: 'tag' },
				{ text: 'Functional location', sortable: false, value: 'functional_locations_str' },
				{ text: 'Modo de Falla Catastrófico', sortable: true, value: 'mfl_event' },
				{ text: 'Áreas Impactadas', sortable: true, value: 'impacted_areas_names' },
				/* { text: 'Estándar', value: 'standard_name' }, */
				/* { text: 'Impacto', value: 'max_impact_name_j', },
				{ text: 'Máxima Severidad', value: 'max_mfl', class:['width100px','thwb']}, */
				{ text: 'Cálculo de MFL Financiero', value: 'computed_financial_mfl', /* class: ['width100px','thwb'] */ },
    	],
			preFilters:{is_deleted: false},
			rq_name: 'join/critical_asset/detail/functional_location',
		}
	},
	computed:{
		organizations() { return this.$store.getters.organizations },
		standards() { return this.$store.getters.standards },
		c_name(){ return this.pre_name? `${this.pre_name}-${this.rq_name}`: this.rq_name },
	},
	methods:{
		beforeSetRows(items){
			this.dev_log({items},this.standards);
			items.forEach(item => {
				item.standard_name = fN(this.standards, item.standard);
				item.organization_name = (this.organizations.find(f=>f.id === item.organization)||{}).name;
				item.impacted_areas_names = inpAreasNames(item.impacted_areas);
				item.functional_locations_str = this.j(item.functional_locations.map(m=>m.functional_location));
			});
			return items;
		}
	}
};
</script>